import config from "./config";
var axios = config();

export default {
  getEmployeeJobs(asuriteId) {
    return axios.get("/api/Employees/GetEmployeeJobs/" + asuriteId);
  },

  getUnsubmittedFaculty(timePeriodId) {
    return axios.get("/api/Employees/GetUnsubmittedFaculty/" + timePeriodId);
  },

  getFaculty() {
    return axios.get("/api/Employees/GetFaculty/");
  },

  getWorkloadFaculty() {
    return axios.get("/api/Employees/GetWorkloadFaculty/");
  },

  getClasses(asurite) {
    return axios.get("/api/employees/" + asurite + "/classes");
  },

  getAwards(asurite) {
    return axios.get("/api/employees/" + asurite + "/awards");
  },

  getProjects(asurite) {
    return axios.get("/api/employees/" + asurite + "/projects");
  },

  getProposals(asurite) {
    return axios.get("/api/employees/" + asurite + "/proposals");
  },

  getCollaborators(asurite) {
    return axios.get("/api/employees/" + asurite + "/collaborators");
  },

  getCommunityPartners(asurite) {
    return axios.get("/api/employees/" + asurite + "/community-partners");
  },

  getTranslationalTeams(asurite) {
    return axios.get("/api/employees/" + asurite + "/translational-teams");
  },

  getExpertise(asurite) {
    return axios.get("/api/employees/" + asurite + "/expertise");
  },

  getByTag(tagId) {
    return axios.get("/api/employees/tag/" + tagId);
  },

  getEmployeeNotes(asuriteId) {
    return axios.get("/api/employees/notes/" + asuriteId);
  },

  postEmployeeNote(note) {
    return axios.post("/api/employees/notes", note);
  }
};
